lmApp.service('ManagerResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/managers',
    null,
      {
        get: {
          params: {},
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          },
          isArray: true,
          transformResponse: function (data) {
            var result = angular.fromJson(data);
            return result.data || []
          }
        },
        update: {
          url: '/discovery:80/sdp/v2/managers/:id',
          method: 'PATCH',
          params: {
            id: '@id'
          },
          transformRequest: function (data) {
            var body = _.pick(data, [
              'first_name',
              'last_name',
              'ui_timezone'
            ]);
            return angular.toJson(body);
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
          }
        },
        setPassword: {
          url: '/discovery:80/sdp/v2/managers/:id/commands/change-password',
          method: 'POST',
          params: {
            id: '@id'
          },
          transformRequest: function (data) {
            var params = [];
            for (var v in data)
              params.push(encodeURIComponent(v) + "=" + encodeURIComponent(data[v]));
            return params.join("&")
          },
          headers: {
            'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      }
  );
}]);
